<script>
import lazyLoadComponent from '@router/lazyload-component'
import { prepaidOrderStatusFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'

export default {
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    ReservationOrderDetail: () => lazyLoadComponent(import('@components/Orders/ReservationOrderDetail')),
  },
  filters: {
    prepaidOrderStatusFilter,
    formatDate,
  },
  props: {
    defaultValue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showCancelDeductOrder: false,
      drawerVisible: false,
      drawerOrderData: {},
      componentOrderKey: 0,
      tryingGetOrder: false,
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build'
    }
  },
  computed: {
    filterDeductOrders() {
      const deductedStatus = [1, 2, 3, 4, 5, 6]
      return this.showCancelDeductOrder ? this.defaultValue.deductOrders : this.defaultValue.deductOrders.filter((order) => deductedStatus.includes(order.status))
    },
  },
  methods: {
    formatDate,
    async tryToGetOrder(orderId) {
      try {
        this.tryingGetOrder = true
        this.drawerOrderData = await this.$store.dispatch('order/fetchSingle', orderId)
        this.drawerVisible = true
      } finally {
        this.tryingGetOrder = false
      }
    },
    onClickClose() {
      this.$emit('close')
    },
  },
}
</script>
<template>
  <div :class="$style.orderformSection">
    <div class="orderformSection__right__header">
      <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i class="el-dialog__close el-icon el-icon-close"></i></button>
      <h4 class="orderformSection__right__title">客戶使用歷程</h4>
    </div>
    <div v-loading="tryingGetOrder" element-loading-text="取得訂單資訊中..." class="orderformSection__right__content">
      <el-switch v-model="showCancelDeductOrder" class="mb-4 isStylePrepaidUsed" active-text="顯示已取消訂單"></el-switch>
      <el-timeline v-if="filterDeductOrders.length > 0" :class="$style.history">
        <el-timeline-item
          v-for="order in filterDeductOrders"
          :key="order.id"
          :timestamp="`訂單成立時間：${formatDate(order.created, 'dateTime')}`"
          :type="order.status | prepaidOrderStatusFilter('color')"
        >
          <div class="d-flex align-items-center">
            <BaseStateLabel :state="order.status | prepaidOrderStatusFilter('color')" text>{{ order.status | prepaidOrderStatusFilter('text') }}</BaseStateLabel>
            <el-button class="history__title text-decoration-underline p-0" type="text" @click="tryToGetOrder(order.id)">{{ order.id }}</el-button>
            <span class="history__meta">・{{ order.startDate | formatDate('dateTime') }}</span>
          </div>
          <div class="history__meta" style="margin-top: 8px">使用 {{ order.deductTimes }} 次抵扣：{{ order.priceTitle }}</div>
        </el-timeline-item>
      </el-timeline>
      <div v-else>
        尚未有任何使用紀錄
      </div>
    </div>

    <!-- 編輯預約訂單 -->
    <el-drawer
      class="only-close"
      :class="{ 'appStyle': appStyle }"
      custom-class="order-drawer"
      destroy-on-close
      append-to-body
      :visible.sync="drawerVisible"
      :size="$root.isSmallDevice ? '100%' : '90%'"
      :wrapper-closable="false"
      @closed="componentOrderKey++"
    >
      <ReservationOrderDetail 
        :default-value.sync="drawerOrderData"
        order-type="reservation" 
      />
    </el-drawer>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {
  :global {
    .orderformSection {
      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }
        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;
          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }
          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }
          .el-tabs__nav-wrap::after {
            display: none;
          }
          .el-tabs__header {
            margin-bottom: 0;
          }
          .el-tabs--top {
            margin-left: 60px;
            @include max-lg {
              margin-left: 30px;
            }
          }
        }
        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;
          @include max-lg {
            padding: 20px;
          }
        }
      }
    }
    .payment-radio {
      width: 100%;
      h6 {
        margin-top: 0;
      }
      :global {
        .el-radio-group {
          display: flex;
          flex-wrap: wrap;
          margin-right: -15px;
        }
        .el-radio {
          margin-right: 15px;
          border-radius: 7px;
          margin-left: 0 !important;
          width: calc(50% - 15px);
          background-color: #fff;
          margin-bottom: 15px;
        }
      }
    }
  }
}

.history {
  :global {
    .history {
      &__title {
        margin-left: 10px;
      }
      &__meta {
        color: $color-text-light;
      }
    }
  }
}
</style>
